// Lê o cookie "de aceno" que o backend seta/limpa junto do cookie real de
// sessão (admin_token, httpOnly — nunca legível aqui) em authController.js.
// Esse aqui NÃO é httpOnly de propósito: não carrega token nem dado
// nenhum, só um flag de presença ('1'), pra decidir sem perguntar ao
// backend se vale a pena checar sessão de verdade (evita um /auth/me — e o
// 401 esperado dele — pra quem nunca logou, a esmagadora maioria dos
// visitantes de página pública). Nome tem que bater exatamente com
// HINT_COOKIE_NAME em backend/src/controllers/authController.js.
const NOME_COOKIE_HINT = 'admin_session_hint';

export function possivelSessaoAdmin() {
  return document.cookie.split('; ').some((par) => par.startsWith(`${NOME_COOKIE_HINT}=`));
}
